import script from "./Overview.vue?vue&type=script&lang=ts&setup=true"
export * from "./Overview.vue?vue&type=script&lang=ts&setup=true"

import "./Overview.vue?vue&type=style&index=0&id=2753660e&scoped=true&lang=less"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2753660e"]])

export default __exports__